import { render, staticRenderFns } from "./consulting01.vue?vue&type=template&id=584b6890&scoped=true&"
import script from "./consulting01.vue?vue&type=script&lang=js&"
export * from "./consulting01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b6890",
  null
  
)

export default component.exports